export default "__VITE_ASSET__BXeAg29V__"